<template>
  <a-modal
    title="更换订单绑定用户"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" v-if="orderid">
        <a-form-item
          style="display: flex;justify-content: center;"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <search-fans-input
            :robotid="robotid"
            v-decorator="['uid',{rules: [{ required: true, message: '必填项'}]}]"
          ></search-fans-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import OrderApi from '@/api/order'
import SearchFansInput from '@/views/components/SearchFansInput'
import { mapActions } from 'vuex'
export default {
  components: {
    SearchFansInput
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      robotid: null,
      orderid: null,
      sourceby: 0,
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show(robotid, orderid, sourceby) {
      this.robotid = robotid
      this.orderid = orderid
      this.visible = true
      this.sourceby = sourceby
    },
    handleSubmit() {
      const {
        form: { validateFields }
      } = this
      validateFields((errors, values) => {
        if (!errors) {
          this.confirmLoading = true
          const data = {
            robotid: this.robotid,
            orderid: this.orderid+'',
            uid: values.uid
          }
          this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: data.robotid,
            type: 'operationorder',
            data: {
              orderid: data.orderid,
              uid: data.uid,
              sourceby: this.sourceby,
              type: '4'
            }
          }).then(result => {
            this.$message.success('发送指令成功')
            this.handleCancel()
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.orderid = null
      this.visible = false
    }
  }
}
</script>
